import React from 'react';
import { AlertCircle, RefreshCw, X } from 'lucide-react';
import './ErrorMessage.css';

const ErrorMessage = ({ message, onRetry, onDismiss }) => {
  return (
    <div className="error-banner">
      <div className="error-content">
        <AlertCircle size={20} className="error-icon" />
        <div className="error-text">
          <strong>Error:</strong> {message}
        </div>
        <div className="error-actions">
          {onRetry && (
            <button onClick={onRetry} className="retry-btn">
              <RefreshCw size={16} />
              Retry
            </button>
          )}
          {onDismiss && (
            <button onClick={onDismiss} className="dismiss-btn">
              <X size={16} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;